module.exports = __webpack_public_path__ + "media/images/img-family-3-8ed78641.jpg";